import type { ColumnDef } from '@tanstack/vue-table'
import { h } from 'vue'
import { Badge } from '@/components/ui/badge'
import { formatDistanceToNow } from 'date-fns'
import { ArrowUpDown, ChevronDown } from 'lucide-vue-next'
const getBadgeColor = (status: string) => {
  status = status.toLowerCase();
  switch (status) {
    case 'armed':
      return 'default'
    case 'inactive':
      return 'outline'
    case 'disarmed':
      return 'destructive'
    default:
      return 'default'
  }
}

export const columns: ColumnDef<Device>[] = [
  /*{
    accessorKey: 'id',
    header: () => h('div', { class: 'text-right' }, 'ID'),
    cell: ({ row }) => {
      const formatted = String(row.getValue('id'))
      return h('div', { class: 'text-right font-medium' }, formatted)
    },
  },*/
  {
    accessorKey: 'name',
    header: () => h('div', { class: 'text-right' }, 'Nazwa'),
    cell: ({ row }) => {
      const formatted = String(row.getValue('name'))
      return h('div', { class: 'text-right' }, formatted)
    },
  },
  
  {
    accessorKey: 'status',
    header: () => h('div', { class: 'text-right' }, 'Stan'),
    cell: ({ row }) => {
      const formatted = String(row.getValue('status'))
      const variant = getBadgeColor(formatted);
      return h('div', { class: 'text-right' }, [
        h(Badge, { variant }, () => formatted)
      ])
    },
  },
  {
    accessorKey: 'active',
    header: () => h('div', { class: 'text-right' }, 'Aktywny'),
    cell: ({ row }) => {
      const active = Boolean(row.getValue('active'))
      return h('div', { class: 'text-right' }, [
        h(Badge, { variant: active ? 'default' : 'outline' }, () => active ? 'Tak' : 'Nie')
      ])
    },
  },
  {
    accessorKey: 'location',
    header: () => h('div', { class: 'text-right' }, 'Lokalizacja'),
    cell: ({ row }) => {
      const formatted = String(row.getValue('location'))
      return h('div', { class: 'text-right font-medium' }, formatted)
    },
  },
  {
    accessorKey: 'lastSeen',
    header: () => h('div', { class: 'text-right' }, 'Widziano'),
    cell: ({ row }) => {
      const raw = row.getValue('lastSeen') as string | number | Date
      const date = new Date(Number(raw)*1000);
      const formatted = formatDistanceToNow(date, { addSuffix: true })
      return h('div', { class: 'text-right' }, formatted)
    },
  },
]